import { DialogProps } from '@mui/material/Dialog';
import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

// declare module '@mui/material/Dialog' {
//   interface DialogPropsVariantOverrides {
//     userDialog: true;
//   }
// }

export function dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          bottom: 'none !important',
        },
        paper: ({ ownerState }: { ownerState: DialogProps }) => ({
          boxShadow: theme.customShadows.dialog,
          // borderRadius: theme.shape.borderRadius * 2,
          width: '100%',
          ...(!ownerState.fullScreen && {
            margin: theme.spacing(0),
          }),
        }),
        paperFullScreen: {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
        },
      },
    },
    DialogCard: {
      styleOverrides: {
        paper: ({ ownerState }: { ownerState: DialogProps }) => ({
          boxShadow: theme.customShadows.dialog,
          borderRadius: theme.shape.borderRadius * 2,
          ...(!ownerState.fullScreen && {
            margin: theme.spacing(2),
          }),
        }),
        paperFullScreen: {
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 3),
        },
        dividers: {
          borderTop: 0,
          borderBottomStyle: 'dashed',
          paddingBottom: theme.spacing(3),
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '& > :not(:first-of-type)': {
            marginLeft: theme.spacing(1.5),
          },
        },
      },
    },
  };
}
